import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "q-py-lg q-px-md bg-yellow-1 text-center" }
const _hoisted_2 = {
  key: 0,
  class: "text-body1 q-mb-md q-px-xl"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "Important:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "Important:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_request_support_btn = _resolveComponent("request-support-btn")!
  const _component_message = _resolveComponent("message")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.done)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.platform.auth === null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(" If " + _toDisplayString(_ctx.platform.name) + " provided multiple .zip files to download or you require any assistance, ", 1),
                _hoisted_5,
                _createTextVNode(" please click the \"I Need Help\" button below. ")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createTextVNode(" If you require any assistance, please click the \"I Need Help\" button below. ")
              ]))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.done)
      ? (_openBlock(), _createBlock(_component_request_support_btn, {
          key: 1,
          platform: _ctx.platform,
          "get-account-id": _ctx.getAccountId,
          onDone: _cache[0] || (_cache[0] = ($event: any) => (_ctx.done = true))
        }, null, 8, ["platform", "get-account-id"]))
      : (_openBlock(), _createBlock(_component_message, {
          key: 2,
          type: "positive",
          class: "text-body1"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Thank you for informing us that you need help. A member of our support team will contact you via email shortly. ")
          ]),
          _: 1
        }))
  ]))
}